import { useState } from "react";
import { Heart, User, Menu, X, Search, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import SearchBar from "../common/SearchBar";

const Header = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  const [mobileSearch, setMobileSearch] = useState(false);
  const [wishlisted, setWishlisted] = useState(false);

  return (
    <>
      <header className="bg-white w-full z-40 shadow-[0_2px_8px_rgba(0,0,0,0.06)] border-b border-gray-100 sticky top-0">
        <div className="flex items-center justify-between px-3 xs:px-4 md:px-7 py-3.5 xs:py-3 relative min-h-[58px] xs:min-h-[64px]">

          {/* ── LEFT ── */}
          <div className="flex justify-start items-center w-1/3">
            <div className="hidden md:block w-full max-w-sm">
              <SearchBar />
            </div>

            <div className="flex md:hidden items-center gap-1.5 xs:gap-2">
              <button
                onClick={() => { setMobileMenuOpen(!mobileMenuOpen); setMobileSearch(false); }}
                className="w-8 h-8 xs:w-9 xs:h-9 flex items-center justify-center rounded-xl transition-all active:scale-90"
                style={{ background: mobileMenuOpen ? "#F5F0E8" : "transparent" }}
                aria-label="Menu">
                {mobileMenuOpen
                  ? <X size={19} className="text-[#1A1A1A]"/>
                  : <Menu size={19} className="text-[#1A1A1A]"/>}
              </button>
              <button
                onClick={() => { setMobileSearch(s => !s); setMobileMenuOpen(false); }}
                className="w-8 h-8 xs:w-9 xs:h-9 flex items-center justify-center rounded-xl transition-all active:scale-90"
                style={{ background: mobileSearch ? "#F5F0E8" : "transparent" }}
                aria-label="Search">
                <Search size={18} className="text-[#1A1A1A]"/>
              </button>
            </div>
          </div>

          {/* ── CENTER — Logo ── */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
 <Link
  to="/"
  className="block text-4xl sm:text-4xl md:text-[42px] lg:text-[48px] xl:text-[52px] tracking-wide transition-transform duration-300 hover:scale-105"
  style={{
    fontFamily: "'Dancing Script', cursive",
    color: "#000",
    fontWeight: 600,
    textShadow: "1px 2px 4px rgba(0,0,0,0.12)",
  }}
>
  Aishcraft
</Link>
          </div>

          {/* ── RIGHT — Icons ── */}
          <div className="flex justify-end items-center gap-0.5 xs:gap-1 md:gap-3 w-1/3">
            <button
              onClick={() => setWishlisted(w => !w)}
              className="hidden md:flex w-9 h-9 items-center justify-center rounded-xl text-[#1A1A1A] hover:bg-gray-50 transition-all hover:scale-110 active:scale-90"
              aria-label="Wishlist">
              <Heart
                size={20}
                fill={wishlisted ? "#E53935" : "none"}
                stroke={wishlisted ? "#E53935" : "currentColor"}
                className="transition-colors duration-200"
              />
            </button>

            <button
              className="w-8 h-8 xs:w-9 xs:h-9 flex items-center justify-center rounded-xl text-[#1A1A1A] hover:bg-gray-50 transition-all hover:scale-110"
              aria-label="Account">
              <User size={19}/>
            </button>

           <Link
  to="/cartPage"
  className="w-8 h-8 xs:w-9 xs:h-9 flex items-center justify-center rounded-xl text-[#1A1A1A] hover:bg-gray-50 transition-all hover:scale-110 relative"
  aria-label="Cart"
>
  <ShoppingBag size={19} />
  <span
    className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-bold text-white leading-none"
    style={{ background: "#1A1A1A" }}
  >
    0
  </span>
</Link>

            <button
              onClick={() => setWishlisted(w => !w)}
              className="md:hidden w-8 h-8 xs:w-9 xs:h-9 flex items-center justify-center rounded-xl text-[#1A1A1A] hover:bg-gray-50 transition-all active:scale-90"
              aria-label="Wishlist">
              <Heart
                size={18}
                fill={wishlisted ? "#E53935" : "none"}
                stroke={wishlisted ? "#E53935" : "currentColor"}
                className="transition-colors duration-200"
              />
            </button>
          </div>
        </div>

        {/* ── MOBILE SEARCH BAR ── */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${mobileSearch ? "max-h-20 opacity-100" : "max-h-0 opacity-0"}`}>
          <div className="px-3.5 xs:px-4 pb-3 pt-1">
            <div className="relative">
              <Search size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400"/>
              <input
                autoFocus={mobileSearch}
                type="text"
                placeholder="Search planners, journals, photobooks..."
                className="w-full pl-9 pr-4 py-2.5 text-[13px] rounded-2xl outline-none border border-gray-200 focus:border-gray-400 transition-colors bg-gray-50"
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;